export default function isImageByExtension(ext) {
    return ("bmp jpg png gif ico jpeg".split(" ").indexOf(ext) >= 0);
}
